import styled from 'styled-components';
import { body2 } from 'ui/theme';
import { FieldProps } from 'lib/iterable-hook-form';

export const READONLY_FIELD_TEST_ID_PREFIX = 'form-readonly-field-';

/**
 * Generates test id for `ReadOnlyField`
 * @param name
 */
export const getReadOnlyFieldTestId = (name: FieldProps['name']) =>
  `${READONLY_FIELD_TEST_ID_PREFIX}${name}`;

const FieldWrapper = styled.div`
  ${body2};
  width: 100%;
  display: flex;
  align-items: center;
  overflow: hidden;
  word-break: break-word;
  white-space: break-spaces;
  gap: 7.5px;
`;

export type ReadOnlyFieldProps = FieldProps & { children: React.ReactNode; className?: string };

export const ReadOnlyField = ({ children, name, className }: ReadOnlyFieldProps) => {
  return (
    <FieldWrapper
      data-test={getReadOnlyFieldTestId(name)}
      aria-readonly={true}
      className={className}
    >
      {children}
    </FieldWrapper>
  );
};
